import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ContentLoader from "react-content-loader";
import Helper from "../../Helper";
import { getTrans as t } from "../../Localization/translations";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import axios from "axios";
import { API } from "../../backend";
import authHeader from "../../services/auth-header";
import { ToastContainer, toast } from "react-toastify";
import MaterialTable from "material-table";
import ApprovalAction from "../Approvals/ApprovalAction";
import ApprovalDetails from "../Approvals/ApprovalDetails";


function ViewManualAccounting() {
    // const { state: manualId } = useLocation();
    const location = useLocation();
    const navigate = useNavigate();
    // From state (app navigation)
    const manualIdFromState = location.state;
    // From query (email link)
    const query = new URLSearchParams(location.search);
    const manualIdFromQuery = query.get("transaction_id");
    // Final ID
    const manualId = manualIdFromState || manualIdFromQuery;
    const [manual, setManual] = useState(null);
    const [loading, setLoading] = useState(true);
    const [glEntries, setGlEntries] = useState([]);

    const [approvalTaskId, setApprovalTaskId] = useState(null);
    const [approvalHistory, setApprovalHistory] = useState([]);
    const [approvalRequestId, setApprovalRequestId] = useState(null);


    useEffect(() => {
        if (!manualId) {
            navigate("/manualaccounting");
            return;
        }
        //  CLEAN URL (remove query param after reading)
        if (manualIdFromQuery) {
            navigate("/viewmanualaccounting", {
                replace: true,
                state: manualId
            });
        }
        axios
            .get(API + `manualaccounting/${manualId}/`, {
                headers: authHeader(),
            })
            .then((res) => {
                setManual(res.data);
                setLoading(false);
            })
            .catch(() => {
                toast.error("Failed to load manual entry");
                setLoading(false);
            });

        axios
            .get(API + `manualaccounting/${manualId}/accounting-entries/`, {
                headers: authHeader(),
            })
            .then(res => setGlEntries(res.data || []));


        // Approval History
        axios.get(API + `approvals/history/${manualId}/`, {
            headers: authHeader(),
            params: { type: "manual" }
        })
            .then(res => setApprovalHistory(res.data || []))
            .catch(() => setApprovalHistory([]));


        // Approval Task
        const isManual = window.location.pathname.includes("manual");
        const type = isManual ? "manual" : "expense";
        axios.get(
            API + `approvals/task/${manualId}/?type=${type}`,
            { headers: authHeader() }
        )
            .then(res => {
                setApprovalTaskId(res.data.task_id);
                setApprovalRequestId(res.data.request_id);
            });

    }, [manualId, navigate]);

    const approvalRequest = manual
        ? {
            id:
                manual.approval_status === "Draft"
                    ? manual.id
                    : approvalTaskId,
            status: manual.approval_status
        }
        : null;



    if (loading || !manual) {
        return (
            <ContentLoader viewBox="0 0 400 160">
                <rect x="0" y="13" rx="4" ry="4" width="400" height="9" />
                <rect x="0" y="29" rx="4" ry="4" width="100" height="8" />
                <rect x="0" y="50" rx="4" ry="4" width="400" height="10" />
            </ContentLoader>
        );
    }

    const handleFinalize = async () => {
        try {
            await axios.post(
                API + `manualaccounting/${manualId}/finalize/`,
                {},
                { headers: authHeader() }
            );

            toast.success("Entry finalized");
            navigate("/transactions");
        } catch (err) {
            toast.error("Failed to finalize");
        }
    };






    return (
        <div className="page-wrapper">
            <ToastContainer />

            <div className="container-fluid">
                <div className="row">
                    <div className="header pt-3">
                        <h5 className="title mb-0">{t("Manual Accounting")}</h5>
                        <h6>
                            <Link to="/manualaccounting" className="tc">
                                {t("Manual Accounting")}
                            </Link>{" "}
                            / <span>{t("View Accounting")}</span>
                        </h6>
                    </div>

                    {/* LEFT CARD */}
                    <div className="col-xl-8 col-md-8 col-sm-12">
                        <div className="card">
                            <div className="card-body">

                                <div className="row">
                                    <div className="col-xl-8 d-flex">
                                        <label className="col-lg-8 col-form-label">{t("Sub Company")}</label>
                                        <div className="col-6 d-flex">
                                            <p className="view-label p">{manual.subcompany_name || "-"}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-xl-8 d-flex">
                                        <label className="col-lg-8 col-form-label">{t("Line of Business")}</label>
                                        <div className="col-6 d-flex">
                                            <p className="view-label p">{manual.line_of_business_name || "-"}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-8 d-flex">
                                        <label className="col-lg-8 col-form-label">
                                            {t("Accounting Number")}
                                        </label>
                                        <div className="col-6 d-flex">
                                            <span className="view-label p">
                                                {manual.accounting_number}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-8 d-flex">
                                        <label className="col-lg-8 col-form-label">
                                            {t("Accounting Date")}
                                        </label>
                                        <div className="col-6 d-flex">
                                            <p className="view-label p">
                                                {Helper.DateNormal(manual.entry_date)}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-xl-8 d-flex">
                                        <label className="col-lg-8 col-form-label">
                                            {t("Debit Account")}
                                        </label>
                                        <div className="col-6 d-flex">
                                            <p className="view-label p">
                                                {manual.debit_account_number
                                                    ? `${manual.debit_account_number} - ${manual.debit_account_name}`
                                                    : "-"}


                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-xl-8 d-flex">
                                        <label className="col-lg-8 col-form-label">
                                            {t("Credit Account")}
                                        </label>
                                        <div className="col-6 d-flex">
                                            <p className="view-label p">
                                                {manual.credit_account_number
                                                    ? `${manual.credit_account_number} - ${manual.credit_account_name}`
                                                    : "-"}


                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-xl-8 d-flex">
                                        <label className="col-lg-8 col-form-label">
                                            {t("Amount")}
                                        </label>
                                        <div className="col-6 d-flex">
                                            <span className="view-label p">
                                                {Helper.Amount(manual.amount)}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-xl-8 d-flex">
                                        <label className="col-lg-8 col-form-label">
                                            {t("Status")}
                                        </label>
                                        <div className="col-6 d-flex">
                                            <span className="view-label p">
                                                {manual.status}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-8 d-flex">
                                        <label className="col-lg-8 col-form-label">
                                            {t("Approval Status")}
                                        </label>
                                        <div className="col-6 d-flex">
                                            <span className="view-label p">
                                                {manual.approval_status}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-8 d-flex">
                                        <label className="col-lg-8 col-form-label">
                                            {t("Reference")}
                                        </label>
                                        <div className="col-6 d-flex">
                                            <p className="view-label p">
                                                {manual.reference || "None"}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-xl-8 d-flex">
                                        <label className="col-lg-8 col-form-label">
                                            {t("Description")}
                                        </label>
                                        <div className="col-6 d-flex">
                                            <p className="view-label p">
                                                {manual.description || "None"}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="col-xl-4 col-md-8 col-sm-12">
                        <div className="card">

                            {manual?.approval_status === "Approved" || manual?.approval_status === "Rejected" ? (
                                <ApprovalDetails
                                    approvalHistory={approvalHistory}
                                    approvalRequestId={approvalRequestId}
                                />
                            ) : (
                                approvalRequest && (
                                    <ApprovalAction
                                        request={approvalRequest}
                                        approvalTaskId={approvalTaskId}
                                        onSuccess={() => window.location.reload()}
                                        module="manual"
                                    />
                                )
                            )}

                        </div>
                    </div>

                    {/* RIGHT CARD */}
                    {/* <div className="col-xl-4 col-md-8 col-sm-12">
                        <div className="card">
                            <div className="card-body">

                                <div className="row">
                                    <div className="col-xl-8 d-flex">
                                        <label className="col-lg-8 col-form-label">
                                            {t("Accounting Number")}
                                        </label>
                                        <div className="col-6 d-flex">
                                            <span className="view-label p">
                                                {manual.accounting_number}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-xl-8 d-flex">
                                        <label className="col-lg-8 col-form-label">
                                            {t("Amount")}
                                        </label>
                                        <div className="col-6 d-flex">
                                            <span className="view-label p">
                                                {Helper.Amount(manual.amount)}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-xl-8 d-flex">
                                        <label className="col-lg-8 col-form-label">
                                            {t("Status")}
                                        </label>
                                        <div className="col-6 d-flex">
                                            <span className="view-label p">
                                                {manual.status}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div> */}
                </div>

                {/* ALLOCATIONS TABLE */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="row">

                            <label
                                className="col-lg-5 mt-2 col-form-label"
                                style={{ color: "#000000" }}
                            >
                                <h5>{t("Reimbursement Details")}</h5>
                            </label>
                            <div className="col-lg-12 mt-1">
                                <div className="body">
                                    <div className="table-responsive p-0"></div>
                                    <MaterialTable
                                        style={{
                                            padding: "0.5rem",
                                            backgroundColor: "var(--bs-table-bg)",
                                            borderBottomWidth: "1px",
                                            boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                                        }}
                                        columns={[
                                            {
                                                title: t("Contract"),
                                                field: "contract_number",
                                                headerStyle: { fontWeight: "bold", textAlign: "left" },
                                                cellStyle: { fontSize: 12 },
                                            },
                                            {
                                                title: t("Asset"),
                                                field: "asset_number",
                                                headerStyle: { fontWeight: "bold", textAlign: "left" },
                                                cellStyle: { fontSize: 12 },
                                            },
                                            {
                                                title: t("Customer"),
                                                field: "customer_name",
                                                render: row => row.customer_name || "-",
                                                headerStyle: { fontWeight: "bold", textAlign: "left" },
                                                cellStyle: { fontSize: 12 },
                                            },
                                            {
                                                title: t("Amount"),
                                                field: "amount",
                                                render: row => (
                                                    <div style={{ textAlign: "right", fontSize: 12 }}>
                                                        {Helper.Amount(row.amount)}
                                                    </div>
                                                ),
                                                headerStyle: { fontWeight: "bold", textAlign: "right" },
                                            },
                                        ]}
                                        data={manual.allocations}
                                        options={{
                                            headerStyle: {
                                                backgroundColor: "white",
                                                color: "#245C7F",
                                                fontSize: 11,
                                            },
                                            rowStyle: (rowData, index) =>
                                                index % 2 ? { backgroundColor: "#fff" } : {},
                                            sorting: true,
                                            search: false,
                                            toolbar: false,
                                            paging: true,
                                            pageSize: 10,
                                            emptyRowsWhenPaging: false,
                                            pageSizeOptions: [10, 20, 25, 50],
                                            paginationType: "stepped",
                                            showFirstLastPageButtons: false,
                                        }}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                {/* ACCOUNTING ENTRIES */}

                {manual.status === "Final" && (
                    <div className="row mt-4">
                        <div className="col-xl-12">
                            <h5>{t("Accounting Entries")}</h5>

                            <MaterialTable
                                style={{
                                    padding: "0.5rem 0.5rem",
                                    backgroundColor: "var(--bs-table-bg)",
                                    borderBottomWidth: "1px",
                                    boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                                }}
                                columns={[
                                    {
                                        title: "Transaction", field: "transaction",
                                        headerStyle: { fontWeight: "bold", textAlign: "right", width: "12%" },
                                        cellStyle: { textAlign: "center", fontSize: 12 },
                                    },
                                    {
                                        title: "Transaction Type", field: "transaction_type",
                                        headerStyle: { fontWeight: "bold", textAlign: "right", width: "12%" },
                                        cellStyle: { textAlign: "center", fontSize: 12 },
                                    },
                                    {
                                        title: "Transaction Date",
                                        field: "transaction_date",
                                        headerStyle: { fontWeight: "bold", textAlign: "right", width: "12%" },
                                        cellStyle: { textAlign: "center", fontSize: 12 },
                                        render: row => Helper.DateNormal(row.transaction_date),
                                    },
                                    {
                                        title: "Creation Date",
                                        field: "creation_date",
                                        headerStyle: { fontWeight: "bold", textAlign: "right", width: "12%" },
                                        cellStyle: { textAlign: "center", fontSize: 12 },
                                        render: row => Helper.DateNormal(row.creation_date),
                                    },
                                    {
                                        title: "Company", field: "company",
                                        headerStyle: { fontWeight: "bold", textAlign: "right", width: "12%" },
                                        cellStyle: { textAlign: "center", fontSize: 12 },
                                    },
                                    {
                                        title: "Line of Business", field: "line_of_business",
                                        headerStyle: { fontWeight: "bold", textAlign: "right", width: "12%" },
                                        cellStyle: { textAlign: "center", fontSize: 12 },
                                    },
                                    {
                                        title: "Transaction Line", field: "transaction_line",
                                        headerStyle: { fontWeight: "bold", textAlign: "right", width: "12%" },
                                        cellStyle: { textAlign: "center", fontSize: 12 },
                                    },
                                    {
                                        title: "Line Type", field: "line_type",
                                        headerStyle: { fontWeight: "bold", textAlign: "right", width: "12%" },
                                        cellStyle: { textAlign: "center", fontSize: 12 },
                                    },
                                    {
                                        title: "Account Number", field: "account_number",
                                        headerStyle: { fontWeight: "bold", textAlign: "right", width: "12%" },
                                        cellStyle: { textAlign: "center", fontSize: 12 },
                                    },
                                    {
                                        title: "Account Name", field: "account_name",
                                        headerStyle: { fontWeight: "bold", textAlign: "right", width: "12%" },
                                        cellStyle: { textAlign: "center", fontSize: 12 },
                                    },
                                    {
                                        title: "DR/CR", field: "dr_cr",
                                        headerStyle: { fontWeight: "bold", textAlign: "right", width: "12%" },
                                        cellStyle: { textAlign: "center", fontSize: 12 },
                                    },
                                    {
                                        title: "Amount",
                                        field: "amount",
                                        headerStyle: { fontWeight: "bold", textAlign: "right", width: "12%" },
                                        cellStyle: { textAlign: "center", fontSize: 12 },
                                        render: row => (
                                            <div style={{ textAlign: "right" }}>
                                                {Helper.Amount(row.amount)}
                                            </div>
                                        ),
                                    },
                                ]}

                                data={glEntries}
                                options={{
                                    headerStyle: {
                                        backgroundColor: "white",
                                        color: "#245C7F",
                                        fontSize: 11,
                                    },
                                    rowStyle: (_, index) =>
                                        index % 2 ? { backgroundColor: "#fff" } : {},
                                    toolbar: false,
                                    search: false,
                                    paging: false,
                                }}
                            />
                        </div>
                    </div>
                )}

                <div className="text-left py-3">
                    <button
                        type="button"
                        className="btn-cancel-invoice border-0 btn btn-secondary btn-gradient-primary btn-md"
                        onClick={() => navigate("/transactions")}
                    >
                        {t("Cancel")}
                    </button>
                    &nbsp;&nbsp;

                    {manual.approval_status === "Approved" && manual.status === "New" && (
                        <button className="btn btn-primary" onClick={handleFinalize}>
                            Finalize
                        </button>
                    )}

                </div>
            </div>
        </div>
    );
}

export default ViewManualAccounting;
